<app-item [element]="instance().element" [instancesComponent]="instancesComponent()" />
@if (instance().element.discovered) {
  <app-instance-discovered-text />
}
